import React, { useState } from 'react'

import QRCode from "react-qr-code";
import { Link } from 'react-router-dom';
import axios from '../utils/axios';
import useAuth from '../context/hook/useAuth';

import { Header } from '../wallet/header/header'
import { Footer } from '../Home/Footer'
import { MiniHeader } from '../Home/MiniHeader';
import site from "../utils/SiteSettings"

//toast
import 'react-toastify/dist/ReactToastify.css'; // import first and after the toastify is work 
import { toast } from 'sonner'

export const Deposit = () => {

    const { user } = useAuth()

    const [pair, setPair] = useState()

    const [label, setLabel] = useState()

    const [detail, setDetail] = useState([])

    const [Address, setAddress] = useState([])

    const [copyStatus, setCopyStatus] = useState(false);

    //This a one chain ico
    // const getAdd = async () => {
    //     try {
    //         await axios.get(`/useradd`
    //             ,{
    //                 headers:{
    //                     "Content-Type": "application/json",
    //                     "Authorization":user
    //                 },
    //                 withCredentials:true,
    //             }
    //         ).then((res)=>{
    //             // console.log(res)
    //             let result = JSON.parse(res.data)
    //             // console.log(result)
    //             setAddress(result)
    //             // console.log(balance)
    //         }).catch(err => console.log(err))
    //     } catch (error) {
    //         console.log(error)
    //     }
    // }
    // // console.log(Address)
    // useEffect(()=>{
    //     // getAdd()
    //     // eslint-disable-next-line
    // },[])

    const getAddress = async (e) => {
        
        setPair(e.target.value)
        const select = document.getElementById('mySelect');
        const label = select.options[select.selectedIndex].text;
        // console.log(label)
        // select.value = label
        setLabel(label)
        try {
            if(e.target.value === '') return toast.error(`Select a pair`,{position:'top-right'})
            await axios.put(`/particular/address`,
                {
                    coin:e.target.value,
                    command: 'stop'
                },
                {
                    headers:{
                        "Content-Type": "application/json",
                        "Authorization":user
                    },
                    withCredentials:true,
                }
            ).then((res)=>{

                let data = JSON.parse(res.data)
                // console.log(data)
                setDetail(data)
                setAddress(data.add)
            }).catch(err=>{
                console.log(err)
            })
        } catch (error) {
            console.log(error)
        }
    }

    const handleCopy = ()=>{
        try {
            // console.log(Address)
            navigator.clipboard.writeText(Address && Address.toString())
            setCopyStatus(true);
            toast.success("Address copied",{position:'top-right'})
            setTimeout(() => setCopyStatus(false), 2000)
        } catch (error) {
            toast.error("Some thing went wrong. please try to copy directly",{position:"top-right"})
            console.log(error)
        }
    }

  return (
    <div>

        <Header/>

        {/* <!-- service section start --> */}
        <section className="feature-section pb-0">
            <div className="container pb-md-5 pb-0">
                <div className="title-basic fs-sm">
                    {/* <!-- <h2 class="text-white">A Wide Range of
                        Functionality to Support Any Use Case</h2> --> */}
                </div>
                <ul className="tab-section mt-80">
                    <li><Link to={"/wallet"}>Wallet</Link></li>
                    <li><Link to={"/buy/token"}>Buy {site?.site?.siteName}</Link></li>
                    <li className="active"><Link to={""}>Deposit</Link></li>
                    <li><Link to={"/withdrawal"}>Withdraw</Link></li>
                    <li><Link to={"/setting"}>Settings</Link></li>
                    <li><MiniHeader /></li>
                </ul>
                <div className="row g-xxl-5 g-4 justify-content-center">
                <div className="col-lg-5">
                    <div className="buy-box">
                        <div className="buy-head">
                            <h3>Deposit</h3>
                        </div>
                        <div className="deposit-area">
                            <form action="">
                                <div className="form-group">
                                    <label htmlFor="exampleFormControlSelect1">Select Crypto</label>
                                    <select onChange={e=>getAddress(e)} id='mySelect' className="custom-select" required="">
                                        <option value={""}>Select Crypto</option>
                                        {/* <option value="BNB">BNB</option>
                                        <option value="USDT">USDT</option> */}
                                        <option value="BNB">BNB</option>
                                        <option value="BNB">USDT(BEP-20)</option>
                                        {/* <option value="ETH">ETH</option>
                                        <option value="ETH">USDT(ERC-20)</option> */}
                                        {/* <option value="SOL">SOL</option>
                                        <option value="SOL">SOL/USDT</option> */}
                                        <option value="TRX">TRX</option>
                                        <option value="TRX">USDT(TRC-20)</option>
                                        {/* <option value="XRP">XRP</option> */}
                                        {/* <option value="COINST">COINST</option> */}
                                    </select>
                                    {/* <p>{label}</p> */}
                                </div>
                            </form>
                            <div className="el-step__main">
                                <div className="el-step__title is-process">Deposit Address</div>
                                <div className="el-step__description is-process">
                                    <div className="PipoQ">
                                        {/* <p style={{lineHeight: "14px",fontSize:"15px"}}>Important Note: Send only USDT to this address. Sending other cryptos to this address may result in the loss of your deposit.</p> */}
                                        <p style={{lineHeight: "14px",fontSize:"15px"}}>Important Note: Min Deposit should be {label && detail && label == "USDT(BEP-20)" ? `${detail.USDT} USDT` : label == "USDT(TRC-20)" ? `${detail.trc20} USDT` : `${detail.pair} ${pair}`}. Anything below to this will not reflected in your balance</p>
                                        <div className="nwyne">
                                            <ul>
                                                <li>
                                                    <QRCode size={256} className="img-fluid qr-code" style={{ height: "100px", width: "100px" }} value={Address.toString()} />
                                                </li>
                                                <li>
                                                    <p className="luzAm">
                                                        Address 
                                                        <Link to={""} style={{marginLeft: "4px"}}>
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M11.25 5H9.75V11H11.25V5Z" fill="currentColor"></path>
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M2.5 15V11H1V9.5H2.5V6.5H1V5H2.5V1H14.25V15H2.5ZM4 2.5H12.75V13.5H4V11H5.5V9.5H4V6.5H5.5V5H4V2.5Z" fill="currentColor"></path>
                                                            </svg>
                                                        </Link>
                                                    </p>
                                                    <h5>{Address}</h5>
                                                </li>
                                                <li>
                                                    {/* <svg width="16" height="16" viewBox="0 0 16 16" onClick={handleCopy} fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M6 1.75H12.75H14.25V3.25V10H12.75V3.25H6V1.75ZM9.75 6.25H3.25V12.75H9.75V6.25ZM1.75 4.75V14.25H11.25V4.75H1.75Z" fill="#878787"></path>
                                                    </svg>
                                                    {copyStatus && <p><i className="fa-solid fa-square-check"></i></p>} */}
                                                    {
                                                        copyStatus === false ?  
                                                            <svg width="16" height="16" viewBox="0 0 16 16" className='copy-img' onClick={handleCopy} fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M6 1.75H12.75H14.25V3.25V10H12.75V3.25H6V1.75ZM9.75 6.25H3.25V12.75H9.75V6.25ZM1.75 4.75V14.25H11.25V4.75H1.75Z" fill="#ffffff"></path>
                                                            </svg> 
                                                        :  <p>
                                                                <i className="fa-solid fa-square-check"></i>
                                                            </p>
                                                    }
                                                </li>
                                            </ul>
                                        </div>
                                        <ol className="NztVh">
                                            {/* <li>{site?.site?.siteName} supports three ways to deposit USDT. You are able to deposit using the {pair}. Select a protocol to see the corresponding address.</li> */}
                                            <li style={{fontSize:"15px"}}>Ensure that the network is <span className="green">{pair === "BNB" ? "Binance" : pair === "ETH" ? "Ethereum" : pair === "TRX" ? "Tron":"" } {pair === "BNB" ? "(BEP-20)" : pair === "ETH" ? "(ERC-20)" : pair === "TRX" ? "(TRC-20)":"" }  </span>. </li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
        {/* <!-- service section end --> */}

        <Footer/>
    </div>
  )
}
